import { cloneDeep, isEmpty, get, concat } from 'lodash';
import type from './PurchaseOrderType.type';

const initialState = {
  purchaseOrderList: [],
  colourWayList: [],
  supplierList: [],
  poTemplateList: [],
  profileData: null,
  purchaseOrderDetails: null,
  createPoPermission: [],
  tradeRefData: [],
  individualData: null,
  legLengths: [],
  sizesData: [],
  devorderData: null,
  documentList: [],
  dateList: [],
  poHistoryList: [],
  poLogList: [],
  previewData: null,
  previewDevData: null,
  purchaseOrderCount: 0,
};

const ProductCostingReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_PURCHASE_ORDER:
      const updatedArry = cloneDeep(setArrayByCase(state.purchaseOrderList, action.payload));
      return {
        ...state,
        purchaseOrderList: updatedArry,
        purchaseOrderCount: action.payload.data.totalCount,
      };
    case type.SET_MODAL_COLOURWAYSLIST:
      return {
        ...state,
        colourWayList: setList(action.payload),
      };
    case type.SET_MODAL_SUPPLIERLIST:
      return {
        ...state,
        supplierList: setList(action.payload),
      };
    case type.SET_MODAL_PO_TEMPLATE:
      return {
        ...state,
        poTemplateList: setList(action.payload),
      };
    case type.SET_PROFILE:
      return {
        ...state,
        profileData: action.payload,
      };
    case type.SET_PO_DETAILS:
      return {
        ...state,
        purchaseOrderDetails: action.payload,
      };
    case type.SET_CREATE_PO_PERMISSION:
      return {
        ...state,
        createPoPermission: action.payload,
      };
    case type.SET_TRADE_REF:
      return {
        ...state,
        tradeRefData: action.payload,
      };
    case type.GET_EDITED_DATA:
      return {
        ...state,
        individualData: action.payload,
      };

    case type.SET_MATERIAL_PLACEMENT:
      return {
        ...state,
        materialPlacementList: action.payload,
      };
    case type.SET_LEG_LENGTH:
      return {
        ...state,
        legLengths: action.payload,
      };
    case type.SET_SZES:
      return {
        ...state,
        sizesData: action.payload,
      };
    case type.SET_DEVORDER_DATA:
      return {
        ...state,
        devorderData: action.payload,
      };
    case type.DOCUMENT_LIST:
      return {
        ...state,
        documentList: action.payload,
      };
    case type.DATES_LIST:
      return {
        ...state,
        dateList: action.payload,
      };
    case type.SET_PO_HISTORY_DATA:
      return {
        ...state,
        poHistoryList: action.payload,
      };
    case type.SET_PO_LOG_DATA:
      return {
        ...state,
        poLogList: action.payload,
      };
    case type.PREVIEW_DATA:
      return {
        ...state,
        previewData: action.payload,
      };
    case type.PREVIEW_DEV_DATA:
      return {
        ...state,
        previewDevData: action.payload,
      };
    case type.EMPTY_PREVIEW:
      return {
        ...state,
        previewData: null,
        previewDevData: null,
        purchaseOrderDetails: null,
        profileData: null,
      };
    case type.SET_OLD_PO_PREVIEW_DATA:
      return {
        ...state,
        purchaseOrderDetails: action.payload,
      };
    default:
      return state;
  }
};

const setList = (arr) => {
  const arrs = cloneDeep(arr);
  return arrs.map((val) => {
    return { ...val, value: val._id, label: val.name };
  });
};

const setArrayByCase = (array, payload) => {
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    array = [...array, ...payload.data.pos];
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data.pos;
    return array;
  }
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data.pos);
    return array;
  }
  return payload.data.pos;
};

export default ProductCostingReducer;
